export default "__VITE_ASSET__D6Vyjb3I__"